import React, { useEffect, useState } from "react"
import { InstagramGallery } from "instagram-gallery"
import "./InstagramGalleryWrapper.css"
const InstagramGalleryWrapper = () => {
  return (
    <InstagramGallery
      accessToken="IGQWRQTU1Xbm8zTFZATMG5TQ3V3NDZA2cTE3VWdSSENqOVYtbGw5UmZAtSUM2azdGMFZAYTXZA3bGlHOGlyU1ZAtX25TNjFfLUR0eS1yV1FGZAElabDducmpMZAGVTZAmVCMGNOaHJTT3NGdnNGNmFGaEh6ZAVBCMGxpYnBfMEUZD"
      count={24}
      pagination={false}
      // pagination={true}
    />
  )
}

export default InstagramGalleryWrapper
